import CookiesPage from "@modules/cookies/page/CookiePage.js";

const Switcher = {
    innerHtml: '<div class="inner"><div class="knob"></div></div> ',
    registeredClass: {CookiesPage},

    init() {
        this.el = $('[component="Switcher"]');
        if (!this.el.length) return;

        this.el.each(function (index, el) {
            const component = $('<div>');

            $.each(this.attributes, function () {
                component.attr(this.name, this.value);
            })

            $(Switcher.innerHtml).appendTo(component);
            component.attr('key', $(this).attr('name')).removeAttr('hidden').removeAttr('name').insertAfter($(this));
            $(this).removeAttr('component').removeAttr('callback').appendTo(component).addClass('label');

            Switcher.bind(component);
        });
    },

    bind(el) {

        el.click(function (event) {
            if ($(this).is("[on='1']")) {
                Switcher.off($(this));
            } else {
                Switcher.on($(this));
            }
        });

    },

    on(el) {
        el.attr('on', '');

        const key = el.attr('key');
        const callback = el.attr('callback');
        const checkbox = el.find('[type="checkbox"]');
        checkbox.prop('checked', true);

        if (!callback) return;

        let Class = callback.split('.')[0];
        let Method = callback.split('.')[1];

        if (this.registeredClass[Class] && typeof this.registeredClass[Class][Method] === 'function') {
            this.registeredClass[Class][Method](key, 1)
        }
    },

    off(el) {
        el.removeAttr('on');

        const key = el.attr('key');
        const callback = el.attr('callback');
        const checkbox = el.find('[type="checkbox"]');
        checkbox.prop('checked', false);

        if (!callback) return;

        let Class = callback.split('.')[0];
        let Method = callback.split('.')[1];

        if (this.registeredClass[Class] && typeof this.registeredClass[Class][Method] === 'function') {
            this.registeredClass[Class][Method](key, 0)
        }
    }
}

export default Switcher;